import React, { useState, JSX } from 'react';
import { useExperienceContext } from '../hooks/useContexts';
import { DateRanges } from '../utils/DateRanges';
import { IJobSpend } from '../models/business-tools';
import { TDateSelectValues } from '../models/common';
import { BusinessToolsContext } from './BusinessToolsContext';

interface IRequestData {
  startDate: string;
  endDate: string;
  poJobName?: string;
}

interface IBusinessToolsProvider {
  children: React.ReactNode;
}

export const BusinessToolsProvider = ({ children }: IBusinessToolsProvider) => {
  const [jobSpends, setJobSpends] = useState<IJobSpend[]>([]);
  const [dateSelectorValue, setDateSelectorValue] =
    useState<TDateSelectValues>('YTD');
  const [requestData, setRequestData] = useState<IRequestData>(DateRanges.YTD);

  const { configService } = useExperienceContext();

  const businessToolsHostName =
    configService?.ENABLE_NEW_PURCHASE_HISTORY_PAGE === '1'
      ? '/myaccount/purchase-history'
      : '/b2b/account/view/order/summary';

  return (
    <BusinessToolsContext.Provider
      value={{
        jobSpends,
        setJobSpends,
        dateSelectorValue,
        setDateSelectorValue,
        requestData,
        setRequestData,
        businessToolsHostName,
      }}
    >
      {children}
    </BusinessToolsContext.Provider>
  );
};
